import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { ConditionalWrapper } from '../../shared/ConditionalWrapper';
import { processLink } from '../../shared/processLink';
import { SmartLink } from '../SmartLink/SmartLink';

type HeroImageProps = {
    cols: 1 | 2;
    image?: IGatsbyImageData;
    alt?: string;
    imageActionLink?: {
        title: string;
        uri: string;
    };
};

function HeroImage({ image, alt, imageActionLink }: HeroImageProps) {
    const isHeroImageActionLinkAvailable =
        imageActionLink?.uri !== undefined && imageActionLink.uri !== null;

    return (
        <ConditionalWrapper
            condition={isHeroImageActionLinkAvailable}
            wrapper={(children) => (
                <SmartLink
                    href={processLink(imageActionLink?.uri)}
                    aria-label={alt ?? ``}
                    className="hero-action-link"
                >
                    {children}
                </SmartLink>
            )}
        >
            <GatsbyImage
                image={image}
                className={
                    isHeroImageActionLinkAvailable && `hero-image-clickable`
                }
                alt={alt ?? ``}
                tabIndex={isHeroImageActionLinkAvailable ? 0 : undefined}
            />
        </ConditionalWrapper>
    );
}

export default HeroImage;
